/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUsers from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageMaintenanceTeam from "./manageMaintenanceTeam";
import ManageCategories from "./manageCategories/index";
import SubcategoryPage from "./manageCategories/subcategory";
import ManageFaq from "./manageFaq/index";
import ManagePayments from "./managePayments";
import ManageSubadmin from "./manageSubadmin";
import ManageAnalytics from "./manageAnalytics";
import ManageCustomerSupport from "./manageCustomerSupport";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageReviews from "./manageReviews";
import ManageCms from "./manageCms";
import AddUser from "./manageUsers/add";
import AddTeam from "./manageMaintenanceTeam/add";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageVenueOwners from "./manageVenueOwners";
import AddVenueOwner from "./manageVenueOwners/add";
import EditVenueOwner from "./manageVenueOwners/edit";
import ManageStorageOwners from "./manageStorageOwners";
import AddStorageOwner from "./manageStorageOwners/add";
import EditStorageOwner from "./manageStorageOwners/edit";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import ManageBooking from "./manageBookingRequest";
import AddBooking from "./manageBookingRequest/add";
import ViewBookingDetails from "./manageBookingRequest/view";
import LoyaltyPointsDetails from "./LoyaltyPoints/details";
import ManageLoyaltyPoints from "./LoyaltyPoints";
import EditLoyaltyPoints from "./LoyaltyPoints/edit";
import CategoryDetails from "./manageCategories/details";
import ManageBannerDetails from "./banner/details";
import AddBanner from "./banner/add";
import ManageBanner from "./banner";
import AdDiscount from "./discount/add";
import DiscountDetails from "./discount/details";
import ManageDiscount from "./discount";
import ManageNews from "./news";
import AddNews from "./news/add";
import NewsDetails from "./news/details";
import AddRecommendedVenue from "./recommendedVenue/add";
import EditRecommendedVenue from "./recommendedVenue/edit";
import ManageRecommendedVenue from "./recommendedVenue";
import RecommendedVenueDetails from "./recommendedVenue/details";
import ManageAmenities from "./amenities";
import AmenitiesDetails from "./amenities/details";
import AddAmenities from "./amenities/subcategory";
import ManageOwnerDetail from "./manageUsers/Owner/details";
import VenueOwnerDetails from "./manageVenueOwners/details";
import ManageFacilities from "./manageFacilities";
import ManageBlogs from "./manageBlogs";
import AddBlog from "./manageBlogs/add";
import BlogDetails from "./manageBlogs/details";
import BookingDetails from "./manageBookingRequest/view"
import ManageHostPayout from "./manageHostPayout";
import ManageRefunds from "./manageRefunds";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUsers,
  ManageUserDetail,
  AddUser,
  ManageMaintenanceTeam,
  AddTeam,
  ManageVenueOwners,
  AddVenueOwner,
  EditVenueOwner,
  ManageStorageOwners,
  AddStorageOwner,
  EditStorageOwner,
  ManageCategories,
  SubcategoryPage,
  ManagePayments,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageAnalytics,
  ManageCustomerSupport,
  ManageNotifications,
  RecievedNotifications,
  ManageReviews,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageBooking,
  AddBooking,
  ViewBookingDetails,
  LoyaltyPointsDetails,
  ManageLoyaltyPoints,
  EditLoyaltyPoints,
  CategoryDetails,
  ManageBannerDetails,
  AddBanner,
  ManageBanner,
  AdDiscount,
  DiscountDetails,
  ManageDiscount,
  AddRecommendedVenue,
  EditRecommendedVenue,
  ManageRecommendedVenue,
  RecommendedVenueDetails,
  ManageNews,
  AddNews,
  NewsDetails,
  ManageAmenities,
  AmenitiesDetails,
  AddAmenities,
  ManageFaq,
  ManageOwnerDetail,
  VenueOwnerDetails,
  ManageFacilities,
  ManageBlogs,
  AddBlog,
  BlogDetails,
  BookingDetails,
  ManageHostPayout,
  ManageRefunds,
};
